import Airtable from "airtable";

const base = new Airtable({
  apiKey: process.env.REACT_APP_AIRTABLE_TOKEN,
}).base("appiveuXVMAoCM1SX");

export default base;
